export default __webpack_public_path__ + "static/gitex_thumb_2025-380e6b6106b92abdd5cae4d5f4a170e5.png";